import { gql } from "@apollo/client";

export const LOCKER_OCCUPANCY_PEAK_HOURS = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $lockers: [ID!]
  ) {
    lockerOccupancyPeakHours(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockers: $lockers
    ) {
      hour
      doorSizes {
        size
        dimension
        doors
        avgOccupancyRate
      }
    }
  }
`;

export const PACKAGE_DROPOFF_PEAK_HOURS = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $lockers: [ID!]
    $partnerId: ID
    $partnerBranchIds: [Int]
  ) {
    packageDropoffPeakHours(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockers: $lockers
      partnerId: $partnerId
      partnerBranchIds: $partnerBranchIds
    ) {
      hour
      doorSizes {
        size
        dimension
        packages
        doors
        __typename
      }
      __typename
    }
  }
`;
export const LOCKER_LIST_FOR_PEAK_HOURS = gql`
  query ($operatorId: ID!) {
    lockerInfo(operatorId: $operatorId) {
      lockerId
      lockerName
    }
  }
`;
export const PARTNER_LIST_FOR_PEAK_HOURS = gql`
  query ($operatorId: ID!) {
    searchCouriers(operatorId: $operatorId) {
      partnerId
      companyNickname
    }
  }
`;
